/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)
import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";
import XDownloader from "./Classes/XDownloader";
import CategoryNav from "./Classes/CategoryNav";

import Accordion from './Classes/Accordion';
import AccordionIE from './Classes/AccordionIE';
import ChartTabs from './Classes/ChartTabs';
// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';
import ImageCombination from './Classes/ImageCombination';
import Video from './Classes/Video';
import SliderHandler from "./Classes/SliderHandler";
import LoadArticleInPopup from "./Classes/LoadArticleInPopup";

import Header from './Classes/Header';
import BackToTop from './Classes/BackToTop';
import ScrollTrigger from './Classes/ScrollTrigger';
import ShareButtonLinks from './Classes/ShareButtonLinks';
import LinkAddTargetBlank from './Classes/LinkAddTargetBlank';
import Gri from "./Classes/Gri";

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;

var accordionInstance = null;
var accordionIeInstance = null;
var chartTabs = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var imageCombinationInstance = null;
var videoInstance = null;
var categoryNavInstance = null;
var backToTopInstance = null;
var accordionInstance2 = null;

var headerInstance = null;
var xdownloaderInstance = null;
var loadArticleInPopupInstance = null;
var scrollTriggerInstance = null;

var shareButtonLinks = null;
var linkAddTargetBlankInstance = null;
var texticoninjector = null;
export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {


  focusHandlerInstance = new FocusHandler();

  categoryNavInstance = new CategoryNav();

  lazyLoadInstance = new LazyLoad();

  headerInstance = new Header();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });

  xdownloaderInstance = new XDownloader({
    downloadText: " ", //Can be empty if you want to use an icon instead
    backgroundColor: "bbbbbb", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-', //Class of colored cells
    borderColor: '5A585A', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'bline_bold', //Class for Bold text in Excel
    boldClass2: 'line_bold', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-line',
    borderClass2: 'noline',
    spanBoldClass: 'bold' //Class for Bold text in Excel
  });

  accordionIeInstance = new AccordionIE({
    accordions: '.vr-toggle-accordion'
  });

  accordionInstance = new Accordion({
    accordions: '.js-toggle-accordion'
  });

  accordionInstance2 = new Accordion({
    accordions: '.js-slide-toggler',
  });

  chartTabs = new ChartTabs({
    tabs: '.js-charttabs',
    tabsItem: '.js-charttabs-item',
    tabsItemTextWrapper: '.js-charttabs-text-wrapper',
    tabsItemChartWrapper: '.js-charttabs-chart-wrapper',
    tabsItemText: '.js-charttabs-text',
    tabsItemChart: '.js-charttabs-chart'
  });

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  imageCombinationInstance = new ImageCombination({
    imageCombinationContainer: ".ns-img-combination"
  });

  const storySlider = new SliderHandler({
    sliderType: 'articles',
    outerWrapperSelector: '.slider--story-tiles'
  });

  backToTopInstance = new BackToTop();
  scrollTriggerInstance = new ScrollTrigger();

  loadArticleInPopupInstance = new LoadArticleInPopup({
    article: '.ns-story-tile__link'
  });

  videoInstance = new Video();

  shareButtonLinks = new ShareButtonLinks({
    link: location.href
  });

  linkAddTargetBlankInstance = new LinkAddTargetBlank({
    linkSelector: '.ns-link--target-blank'
  });

  let documentLanguage = document.documentElement.lang;
  let decimalPoint = '';
  let thousandsSep = '';
  let shortMonths = []; // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

  switch (documentLanguage) {
    case "de-DE":
      decimalPoint = ',';
      thousandsSep = '’';
      shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      break;
    case "en-US":
      decimalPoint = '.';
      thousandsSep = ',';
      shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      break;
    case "it-IT":
      decimalPoint = ',';
      thousandsSep = '.';
      shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      break;
    default:
      decimalPoint = ',';
      thousandsSep = '’';
      shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      break;
  }

  new Gri();

  Highcharts.setOptions({
    lang: {
      decimalPoint: decimalPoint, // default: '.'
      numericSymbols: ["k", "M", "G", "T", "P", "E"], // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
      thousandsSep: thousandsSep, // default: '\u0020'
      shortMonths: shortMonths
    }
  });
});
